import React, { useState } from "react";
import "./carousel.scss";
import * as Icon from "react-feather";
const MAX_VISIBILITY = 3;
enum ACTIONS {
  NEXT = "next",
  PREV = "prev",
}
export const Card = ({
  title,
  content,
}: {
  title: string;
  content: string;
}) => (
  <div className="card" style={{ transform: "translateX(10)" }}>
    <h2>{title}</h2>
    <p>{content}</p>
  </div>
);

const Carousel: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [active, setActive] = useState(2);
  const count = React.Children.count(children);

  const onGotoSlide = ({
    nextSlide,
    action,
  }: {
    nextSlide: number;
    action: string;
  }) => {
    if (action === ACTIONS.NEXT) {
      if (nextSlide < count) {
        setActive(nextSlide);
      }
    }
    if (action === ACTIONS.PREV) {
      if (nextSlide >= 0) {
        setActive(nextSlide);
      }
    }
  };

  return (
    <div className="carousel">
      <span
        className="carousel-nav left"
        onClick={() =>
          onGotoSlide({ nextSlide: active - 1, action: ACTIONS.PREV })
        }
      >
        <Icon.ChevronLeft size={60} />
      </span>

      {React.Children.map(children, (child, indx) => (
        <div
          className={`${
            (active === indx && "carousel-item active") || "carousel-item"
          }`}
          style={{
            transform: `translateX(calc(${
              Math.floor(active - indx) * -30
            }%))  translateZ(calc(${(Math.abs(active - indx) / 3) * -320}px))`,
            pointerEvents: active === indx ? "auto" : "none",
            opacity: Math.abs(active - indx) >= MAX_VISIBILITY ? "0" : "1",
            display:
              Math.abs(active - indx) > MAX_VISIBILITY ? "none" : "block",
          }}
        >
          {child}
        </div>
      ))}

      <span
        className="carousel-nav right"
        onClick={() =>
          onGotoSlide({ nextSlide: active + 1, action: ACTIONS.NEXT })
        }
      >
        <Icon.ChevronRight size={60} />
      </span>
    </div>
  );
};

export default Carousel;
